<style scoped>
    .mainBox {
        padding: .66rem .24rem 0;
    }

    .need {
        font-size: .3rem;
        font-weight: bold;
        color: #585858;
        text-align: center;
        margin-bottom: .28rem;
    }

    .price {
        font-size: .6rem;
        font-weight: bold;
        color: #FC3939;
        margin-bottom: .7rem;
        display: flex;
        justify-content: center;
    }

    .line {
        height: 0.01rem;
        background: #DCDCDC;
    }

    .infoBox {
        padding: .27rem 0;
        border-bottom: 0.01rem solid #DCDCDC;
    }

    .infoTitle {
        color: #4D4D4D;
        font-size: .36rem;
        font-weight: bold;
        margin-bottom: .25rem;
    }

    .scaleBox {
        display: flex;
    }

    .scaleBox .scaleLeft {
        width: 1.64rem;
        height: 1.64rem;
        margin-right: .47rem;
        position: relative;
    }

    .scaleLeft .labelName {
        position: absolute;
        top: 0;
        right: 8px;
        padding: .06rem .1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        font-size: .18rem;
        font-weight: bold;
        color: #52C4F6;
        border-radius: 0 0 .08rem .08rem;
    }

    .scaleTitle {
        font-size: .36rem;
        font-weight: bold;
        color: #222222;
        margin-bottom: .22rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .tagline {
        font-size: .24rem;
        font-weight: 500;
        color: #606060;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin-bottom: .4rem;
    }

    .num {
        font-size: .24rem;
        color: #6C6C6C;
    }

    .payBox {
        padding: .26rem 0;
    }

    .layer {
        display: flex;
        justify-content: space-between;
        margin-bottom: .24rem;
    }

    .iconBox {
        display: flex;
        align-items: center;
    }

    .iconBox img {
        width: .42rem;
        height: .42rem;
        margin-right: .26rem;
    }

    .iconBox span {
        font-size: .3rem;
        color: #606060;
        font-weight: bold;
    }

    .choose {
        width: .34rem;
        height: .34rem;
        background: url("~assets/selectIcon.png") no-repeat center/cover;
    }

    .choose.active {
        background: url("~assets/selectIcon2.png") no-repeat center/cover;
    }

    .btn {
        width: 7.02rem;
        height: .7rem;
        background: url("~assets/payBtn.png") no-repeat center/cover;
        margin-top: .4rem;
    }

    .maskBox{
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        background: rgba(0,0,0,.3);
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mask{
        width: 5.6rem;
        border-radius:.2rem;
        background: #fff;
        box-sizing: border-box;
        padding-top: .24rem;
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .maskTitle{
        font-weight: bold;
        font-size: .36rem;
        color: #030303;
        margin-bottom: .3rem;
    }
    .ms{
        margin-bottom: .2rem;
        font-size: .3rem;
        color: #393737;
        /*display: flex;*/
        /*align-items: center;*/
        width: 4.8rem;
    }
    .ms span{
        color:#52C4F6 ;
    }
    .maskLine{
        width: 100%;
        height: 0.02rem;
        background: #E5E5E5;
        margin-top: .26rem;
    }
    .maskBtn{
        width: 100%;
        text-align: center;
        font-size: .36rem;
        color: #4BC1FF;
        margin-top: .2rem;
        margin-bottom: .26rem;
    }
</style>
<template>
    <div style="padding-top: 1rem; padding-bottom: .3rem; min-height: 100vh;background: #fff;">
        <topbar :text="scaleInfo.title"></topbar>
        <div class="mainBox">
            <div class="need">待支付</div>
            <div class="price">￥{{scaleInfo.scalePrice}}</div>
            <div class="line"></div>
            <div class="infoBox">
                <div class="infoTitle">测评订单</div>
                <div class="scaleBox">
                    <div class="scaleLeft"
                         :style="{background: `url(${EnvUrl}${scaleInfo.pic}) no-repeat center/cover`}">
                        <div class="labelName">{{scaleInfo.labelName}}</div>
                    </div>
                    <div class="scaleRight">
                        <div class="scaleTitle">{{scaleInfo.title}}</div>
                        <div class="tagline">{{scaleInfo.tagline}}</div>
                        <div class="num">{{scaleInfo.testCountStr}}人已测试</div>
                    </div>
                </div>
            </div>
            <div class="payBox">
                <div class="infoTitle">支付方式</div>
                <div class="layer" @click="selectPayType(0)" v-if="infoTitle">
                    <div class="iconBox">
                        <img src="../assets/aplipay.png" alt="">
                        <span>支付宝</span>
                    </div>
                    <div class="choose" :class="{'active':payType===0}">
                    </div>
                </div>
                <div class="layer" @click="selectPayType(1)" v-if="wxPay">
                    <div class="iconBox">
                        <img src="../assets/wxpay.png" alt="">
                        <span>微信</span>
                    </div>
                    <div class="choose" :class="{'active':payType===1}">
                    </div>
                </div>
                <div class="btn" @click="ruleStatus=true"></div>
            </div>
            <vue-qr :text="downloadData.url" :margin="0" colorDark="#000" colorLight="#fff" :logoScale="0.3" :size="200"
                    style="margin: .2rem auto;display: block" v-if="payType===1"></vue-qr>
        </div>
        <div class="maskBox" v-if="ruleStatus">
            <div class="mask">
                <div class="maskTitle">温馨提示</div>
                <div class="ms">支付成功后未跳转进入测试的，请点击 <span @click="to('mytest')">『我的测试』</span>选择「已支付」的测试记录并立即测试。</div>
                <div class="maskLine"></div>
                <div class="maskBtn" @click="ruleSure">我知道了</div>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources, getAli} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import vueQr from 'vue-qr'
    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
                ruleStatus:false,
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                scaleId: '',
                scaleInfo: [],
                payType: 0,
                userId: 1,
                testId: '',
                aliPay: true,
                wxPay: true,

                slidesReal: [],
                scaleLabelList: [],
                scaleUserTestList: [],
                indexNum: -1,
                labelId: '',
                pageIndex: 1,
                pageSize: 4,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                count: 0,
                testStatus: 0,
                userAgent: '',
                downloadData: {
                    url: '',
                    icon: 'https://cdn.ysqingxin.com/logo.png'
                },
                tt: '',
                scaleUser:{
                    companyId: '',
                },
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
            vueQr,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {

            selectPayType(n) {
                this.payType = n;
                if (this.downloadData.url) {
                    if (!n) {
                        clearInterval(this.tt)
                    } else {
                        this.tt = setInterval(() => {
                            this.getPayStatus()
                        }, 3000)
                    }
                }
            },
            selectLabel(index, id) {
                this.scaleInfoList = [];
                this.isLoading = false;
                this.indexNum = index;
                this.labelId = id;
                this.pageIndex = 1;
                let obj = {}
                if (index == -1) {
                    obj.recommendStatus = 1;
                } else {
                    obj.labelId = id;
                }
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                this.getScaleInfoList(serialize(obj))
            },
            clickMe(n) {
                this.$router.push(`${n}`)
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            getList(index) {
                this.testStatus = index;
                this.pageIndex = 1;
                this.scaleUserTestList = [];
                this.noMoreData = false;
                this.isLoading = false;
                this.emptyStatus = false;
                this.getScaleUserTestList()
            },
            async getScaleBannerList() {
                let data = await getSources("/bear-scale/api/scaleHomePage/getScaleBannerList.json", serialize({}));
                if (data.status === 0) {
                    this.slidesReal = data.scaleBannerList
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.search()
                    }
                }
            },
            async getScaleInfo() {
                let obj = {}
                obj.scaleId = this.scaleId;
                obj.userAgent = this.userAgent;
                obj.companyId=this.scaleUser.companyId;
                let data = await getSources("/bear-scale/api/scaleInfo/getScaleInfo.json", obj);
                if (data.status === 0) {
                    this.scaleInfo = data.scaleInfo;
                    this.aliPay = data.ALIPAY;
                    this.wxPay = data.WXPAY;
                    if (!this.aliPay) {
                        this.payType = 1;
                    }
                }else{
                    alert(data.msg)
                }
            },
            ruleSure(){
                this.ruleStatus=false;
                this.pay();
            },
            async pay() {
                let obj = {}
                obj.payType = this.payType;
                obj.scaleId = this.scaleId;
                obj.userId = this.userId;
                obj.userAgent = this.userAgent;
                if (this.$route.query.testId) {
                    obj.testId = this.testId;
                }

                let data = await getSources("/bear-scale/api/scaleWallPay/pay.json", obj);
                console.log(data)

                if (data.status === 0) {
//                    this.$router.push(`/selectSex?scaleId=${scaleId}`)
                    if (this.payType === 0) {
                        let form = data.payView;

                        const div = document.createElement('div')
                        div.innerHTML = form//此处form就是后台返回接收到的数据
                        document.body.appendChild(div)
                        document.forms[0].submit()
                    } else {
                        if (data.tradeType === 'MWEB') {
                            location.href = data.mweb_url
                        } else if (data.tradeType === 'JSAPI') {
                            WeixinJSBridge.invoke(
                                'getBrandWCPayRequest',
                                {
                                    appId: data.appId, // 公众号名称，由商户传入
                                    timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                                    nonceStr: data.nonceStr, // 随机串
                                    package: data.package,
                                    signType: data.signType, // 微信签名方式：
                                    paySign: data.paySign // 微信签名
                                },
                                res => {
                                    if (res.err_msg === 'get_brand_wcpay_request:ok') {
//                                        this.$toast({message: '支付成功'})
                                        // 支付成功之后跳转的路由
                                        this.$router.push(`/topic?scaleId=${this.scaleId}&testId=${this.testId}`)
                                    } else {
//                                        this.$toast({message: '支付失败'})
                                        alert(`支付失败`)
                                    }
                                }
                            )
                        } else if (data.tradeType === 'NATIVE') {
                            this.downloadData.url = data.code_url
                            this.tt = setInterval(() => {
                                this.getPayStatus()
                            }, 3000)
                        }
                    }
                } else {
                    alert(data.msg)
                }
            },

            async getPayStatus() {
                let data = await getSources("/bear-scale/api/scaleWallPay/getPayStatus.json", {
                    testId: this.testId
                });
                if (data.status === 0) {
                    if (data.payStatus) {
                        clearInterval(this.tt)
                        this.$router.push(`/topic?scaleId=${this.scaleId}&testId=${this.testId}`)
                    }
                }else{
                    alert(data.msg)
                }
            },
            async getScaleLabelList() {
                let data = await getSources("/bear-scale/api/scaleHomePage/getScaleLabelList.json", {});
                if (data.status === 0) {
                    this.scaleLabelList = data.scaleLabelList
                }else{
                    alert(data.msg)
                }
            },

            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },
        },
        destroyed() {
            if (this.downloadData.url) {
                clearInterval(this.tt)
            }
        },
        mounted() {
            this.userAgent = navigator.userAgent;
            // console.log(navigator)
            if (this.$route.query.testStatus == 0 || this.$route.query.testStatus == 1) {
                this.testStatus = this.$route.query.testStatus
            }
            this.scaleId = this.$route.query.scaleId;
            this.testId = this.$route.query.testId;
            this.userId = localStorage.getItem('userId');

            // let status=JSON.parse(localStorage.getItem('scaleUser'));
            // if(status){
            //     if(status.companyId){
            //         this.scaleUser=JSON.parse(localStorage.getItem('scaleUser'));
            //     }
            // }

            this.getScaleInfo();
//            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pay.vue?7b1a11c1